angular.module('account').controller('AccountDetailsCtrl', [
        '$q',
        '$scope',
        'AccountRepository',
        'aprgettext',
        'ListService',
        'MyChartService',
        'PatientPortalStorageRepository',
        'toaster',
        function (
            $q,
            $scope,
            AccountRepository,
            gettext,
            ListService,
            MyChartService,
            PatientPortalStorageRepository,
            toaster
            ) {
            'use strict';

            $scope.loading = true;

            $scope.isEditingCredentials = false;
            $scope.isSavingCredentials = false;

            $scope.isEditingQuestionAnswers = false;
            $scope.isSavingQuestionAnswers = false;

            $scope.validationMessage = '';

            $scope.securityAccountCredentialsDto = {
                LoginUserId: '',
                UserName: '',
                OldPassword: '',
                NewPassword: ''
            };

            $scope.securityAccountQuestionsAnswersDto = {
                LoginUserId: '',
                Questions: [
                    {
                        Id: null,
                        Text: '',
                        DisplayOrder: 0,
                        Answer: ''
                    },
                    {
                        Id: null,
                        Text: '',
                        DisplayOrder: 1,
                        Answer: ''
                    },
                    {
                        Id: null,
                        Text: '',
                        DisplayOrder: 2,
                        Answer: ''
                    }
                ]
            };

            var accountDetailsDto = {
                    LoginUserId: '',
                    UserName: '',
                    Questions: null
            };


            var loginUser = PatientPortalStorageRepository.getLoginUser();
            ListService.getList('securityquestions', $scope, 'securityQuestions');


            function getMyChartDetails() {
                if (loginUser.isPatient) {
                    return MyChartService.getDetails(loginUser.id)
                        .then(function (data) {
                            $scope.patient = {
                                loginUserId: loginUser.id,
                                name: loginUser.fullName,
                                birthDate: data.DateOfBirth,
                                isPatient: true
                            };
                        });
                }
                else {
                    $scope.patient = {
                        loginUserId: loginUser.id,
                        name: loginUser.fullName,
                        birthDate: null,
                        isPatient: false
                    };
                    return $q.when();
                }
            }

            function getAccountDetails() {
                return AccountRepository.getAccountDetails(loginUser.id)
                    .then(function (data) {
                        accountDetailsDto.LoginUserId = data.LoginUserId;
                        accountDetailsDto.UserName = data.UserName;
                        accountDetailsDto.Questions = data.Questions;
                    });
            }


            function loadView() {
                $scope.loading = true;
                $scope.removeHttpError();

                var myChartPromise = getMyChartDetails();
                var getAccountDetailsPromise = getAccountDetails();

                $q.all([myChartPromise, getAccountDetailsPromise]).then(function () {
                    updateCredentialsScope();

                    var setAnswerToEmptyString = true;
                    updateSecurityQuestionsAnswersScope(setAnswerToEmptyString);
                }).catch(function (response) {
                    $scope.addHttpError(response);
                }).finally(function () {
                    $scope.loading = false;
                });
            }
            loadView();


            function editCredentials() {
                if ($scope.isEditingQuestionAnswers) {
                    cancelQuestionAnswers();
                }

                AccountRepository.getCredentialsMetadata($scope)
                    .then(function() { })
                    .finally(function () {
                        $scope.isEditingCredentials = true;
                    });
            }

            function cancelCredentials(loginCredentialsForm) {
                updateCredentialsScope();
                loginCredentialsForm.$setPristine();
                $scope.isEditingCredentials = false;
            }

            function saveCredentials(loginCredentialsForm) {
                $scope.isSavingCredentials = true;

                if (loginCredentialsForm.$valid) {
                    AccountRepository.putAccountCredentials($scope.securityAccountCredentialsDto)
                        .then(function (data) {
                            accountDetailsDto.LoginUserId = data.LoginUserId;
                            accountDetailsDto.UserName = data.UserName;
                            updateCredentialsScope();

                            $scope.isEditingCredentials = !$scope.isEditingCredentials;
                            loginCredentialsForm.$setPristine();
                            toaster.pop('success', '', gettext('Your password was successfully updated.'));
                        })
                        .catch(function () {
                            $scope.validationMessage = gettext('Please make sure your old password is correct.');
                            toaster.pop('error', '', gettext('Please make sure your old password is correct.'));
                        })
                        .finally(function () {
                            $scope.isSavingCredentials = false;
                        });
                }
                else {
                    $scope.isSavingCredentials = false;
                }
            }


            function editQuestionAnswers() {
                if ($scope.isEditingCredentials) {
                    cancelCredentials();
                }

                AccountRepository.getSecurityQuestionsAnswersMetadata($scope)
                    .then(function () { })
                    .finally(function () {
                        $scope.isEditingQuestionAnswers = true;
                    });
            }

            function cancelQuestionAnswers(securityQuestionAnswersForm) {
                updateSecurityQuestionsAnswersScope(true);
                securityQuestionAnswersForm.$setPristine();
                $scope.isEditingQuestionAnswers = false;
            }

            function saveQuestionAnswers(securityQuestionAnswersForm) {
                $scope.isSavingQuestionAnswers = true;

                if (securityQuestionAnswersForm.$valid) {
                    AccountRepository.putSecurityQuestionsAnswers($scope.securityAccountQuestionsAnswersDto)
                        .then(function (data) {
                            accountDetailsDto.Questions = data.Questions;
                            updateSecurityQuestionsAnswersScope(false);

                            $scope.isEditingQuestionAnswers = !$scope.isEditingQuestionAnswers;

                            securityQuestionAnswersForm.$setPristine();
                            toaster.pop('success', '', gettext('Security Questions and Answers were successfully updated.'));
                        })
                        .catch(function () {
                            $scope.validationMessage = gettext('Security Question and Answers could not be updated.');
                            toaster.pop('error', '', gettext('Security Questions and Answers could not be updated.'));
                        })
                        .finally(function () {
                            $scope.isSavingQuestionAnswers = false;
                        });
                }
                else {
                    $scope.isSavingQuestionAnswers = false;
                }
            }


            function selectedQuestionChanged(selectedSecurityQuestion) {
                if (selectedSecurityQuestion.Id !== null) {
                    var lstProdParamSecurityQuestion = _.find($scope.securityQuestions, {Id: selectedSecurityQuestion.Id});
                    selectedSecurityQuestion.Text = lstProdParamSecurityQuestion.Text;
                }
                else {
                    selectedSecurityQuestion.Text = '';
                }
            }


            function updateCredentialsScope() {
                $scope.validationMessage = '';

                $scope.securityAccountCredentialsDto.LoginUserId = accountDetailsDto.LoginUserId;
                $scope.securityAccountCredentialsDto.UserName = accountDetailsDto.UserName;
                $scope.securityAccountCredentialsDto.OldPassword = '';
                $scope.securityAccountCredentialsDto.NewPassword = '';
            }

            function updateSecurityQuestionsAnswersScope(initializeAnswer) {
                $scope.validationMessage = '';

                $scope.securityAccountQuestionsAnswersDto.LoginUserId = accountDetailsDto.LoginUserId;

                var questionAnswer = _.find($scope.securityQuestions, {Id: accountDetailsDto.Questions[0] && accountDetailsDto.Questions[0].Id});
                if (questionAnswer != null) {
                    $scope.securityAccountQuestionsAnswersDto.Questions[0].Id = questionAnswer.Id;
                    $scope.securityAccountQuestionsAnswersDto.Questions[0].Text = questionAnswer.Text;
                    $scope.securityAccountQuestionsAnswersDto.Questions[0].DisplayOrder = questionAnswer.DisplayOrder;
                    if (initializeAnswer) {
                        $scope.securityAccountQuestionsAnswersDto.Questions[0].Answer = '';
                    }
                }

                questionAnswer = _.find($scope.securityQuestions, {Id: accountDetailsDto.Questions[1] && accountDetailsDto.Questions[1].Id});
                if (questionAnswer != null) {
                    $scope.securityAccountQuestionsAnswersDto.Questions[1].Id = questionAnswer.Id;
                    $scope.securityAccountQuestionsAnswersDto.Questions[1].Text = questionAnswer.Text;
                    $scope.securityAccountQuestionsAnswersDto.Questions[1].DisplayOrder = questionAnswer.DisplayOrder;
                    if (initializeAnswer) {
                        $scope.securityAccountQuestionsAnswersDto.Questions[1].Answer = '';
                    }
                }

                questionAnswer = _.find($scope.securityQuestions, {Id: accountDetailsDto.Questions[2] && accountDetailsDto.Questions[2].Id});
                if (questionAnswer != null) {
                    $scope.securityAccountQuestionsAnswersDto.Questions[2].Id = questionAnswer.Id;
                    $scope.securityAccountQuestionsAnswersDto.Questions[2].Text = questionAnswer.Text;
                    $scope.securityAccountQuestionsAnswersDto.Questions[2].DisplayOrder = questionAnswer.DisplayOrder;
                    if (initializeAnswer) {
                        $scope.securityAccountQuestionsAnswersDto.Questions[2].Answer = '';
                    }
                }
            }


            $scope.saveCredentials = saveCredentials;
            $scope.editCredentials = editCredentials;
            $scope.cancelCredentials = cancelCredentials;
            $scope.saveQuestionAnswers = saveQuestionAnswers;
            $scope.editQuestionAnswers = editQuestionAnswers;
            $scope.cancelQuestionAnswers = cancelQuestionAnswers;
            $scope.selectedQuestionChanged = selectedQuestionChanged;
        }
    ]
);